// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "../../../../../../../node_modules/rescript/lib/es6/curry.js";
import * as React from "react";
import * as ReactModal from "react-modal";
import * as NextRecaptchaV3 from "next-recaptcha-v3";
import * as Config$PorterinUtils from "../../../../../../../node_modules/@porterin/utils/src/configs/Config.mjs";
import * as SharedHelper$PorterinFeature from "../../../core/helpers/SharedHelper.mjs";
import * as RecaptchaProvider$PorterinFeature from "../../../../contexts/recpatcha-context/RecaptchaProvider.mjs";
import * as FareEstimateModalModuleScss from "../styles/FareEstimateModal.module.scss";
import * as FareEstimateHomeModalCmp$PorterinFeature from "./FareEstimateHomeModalCmp.mjs";

var styles = FareEstimateModalModuleScss;

function FareEstimateModalCmp(Props) {
  var modalState = Props.modalState;
  var close_modal = Props.close_modal;
  var category_cards_data = Props.category_cards_data;
  var fare_estimate_form_content = Props.fare_estimate_form_content;
  var modal_content = Props.modal_content;
  var match = React.useState(function () {
        return false;
      });
  var setRecaptchaState = match[1];
  var isRecaptchaFailed = match[0];
  React.useEffect((function () {
          return SharedHelper$PorterinFeature.reloadAfterRecaptchaFailure(isRecaptchaFailed);
        }), [isRecaptchaFailed]);
  return React.createElement(ReactModal, {
              isOpen: modalState,
              onRequestClose: close_modal,
              closeTimeoutMS: 0,
              overlayClassName: styles.overlay,
              className: styles["modal-container"],
              ariaHideApp: false,
              shouldCloseOnOverlayClick: true,
              children: React.createElement(NextRecaptchaV3.ReCaptchaProvider, {
                    reCaptchaKey: Config$PorterinUtils.recaptcha_site_key,
                    useEnterprise: true,
                    children: React.createElement(RecaptchaProvider$PorterinFeature.make, {
                          value: {
                            isRecaptchaFailed: isRecaptchaFailed,
                            setRecaptchaState: (function (flag) {
                                Curry._1(setRecaptchaState, (function (param) {
                                        return flag;
                                      }));
                              })
                          },
                          children: React.createElement(FareEstimateHomeModalCmp$PorterinFeature.make, {
                                close_modal: close_modal,
                                category_cards_data: category_cards_data,
                                fare_estimate_form_content: fare_estimate_form_content,
                                modal_content: modal_content
                              })
                        })
                  })
            });
}

var make = FareEstimateModalCmp;

export {
  styles ,
  make ,
}
/* styles Not a pure module */
